import React from 'react'
import { useSelector } from 'hook'
import { Box, Paper, Typography } from '@material-ui/core'
import { LANGUAGE } from 'constants/language'
import useStyles from './style'
import { TitleText } from 'text/part'

const TitleContent = () => {
  const classes = useStyles()
  const languageManager = useSelector((state) => state.languageManager)
  return (
    <Box className={classes.root}>
      <Paper className={classes.paper} elevation={12}>
        <Typography className={classes.title} noWrap={true}>
          {languageManager === LANGUAGE.JP
            ? TitleText.main.jp
            : TitleText.main.en}
        </Typography>
        <Typography className={classes.subtitle}>
          {languageManager === LANGUAGE.JP
            ? TitleText.sub.jp
            : TitleText.sub.en}
        </Typography>
      </Paper>
    </Box>
  )
}

export default TitleContent
